/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Audio_Recorder_Pre_Roll_MaxInputs */

const en_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(max: ${i?.seconds}s)`)
};

const fr_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(max : ${i?.seconds}s)`)
};

const de_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(max: ${i?.seconds}s)`)
};

const it_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(massimo: ${i?.seconds}s)`)
};

const ru_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(макс.: ${i?.seconds}s)`)
};

const es_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(máximo: ${i?.seconds}s)`)
};

const zh_cn2_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（最大值：${i?.seconds}s）`)
};

const ja_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(最大: ${i?.seconds} 秒)`)
};

const hi_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(अधिकतम: ${i?.seconds}s)`)
};

const pt_pt2_audio_recorder_pre_roll_max = /** @type {(inputs: Audio_Recorder_Pre_Roll_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(máx.: ${i?.seconds}s)`)
};

/**
* | output |
* | --- |
* | "(max: {seconds}s)" |
*
* @param {Audio_Recorder_Pre_Roll_MaxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_pre_roll_max = /** @type {((inputs: Audio_Recorder_Pre_Roll_MaxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Pre_Roll_MaxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_pre_roll_max(inputs)
	if (locale === "de") return de_audio_recorder_pre_roll_max(inputs)
	if (locale === "it") return it_audio_recorder_pre_roll_max(inputs)
	if (locale === "ru") return ru_audio_recorder_pre_roll_max(inputs)
	if (locale === "es") return es_audio_recorder_pre_roll_max(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_pre_roll_max(inputs)
	if (locale === "ja") return ja_audio_recorder_pre_roll_max(inputs)
	if (locale === "hi") return hi_audio_recorder_pre_roll_max(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_pre_roll_max(inputs)
	return en_audio_recorder_pre_roll_max(inputs)
});